/** Keep in sync with backend services/authorization_catalog.py */
export const SCREEN_API_PATH_HINTS = {
  'vendor-dashboard': ['/vendor/application', '/vendor/queries'],
  'vendor-registration': ['/vendor/application', '/upload', '/files'],
  'admin-dashboard': ['/admin/dashboard'],
  'admin-applications': ['/admin/applications'],
  'admin-application-detail': ['/admin/applications/', '/admin/audit-logs', '/upload', '/files'],
  'admin-stores': ['/rfq', '/quotation', '/po', '/invoice'],
  'admin-authorizations': ['/elevated-access-config'],
  'admin-users': ['/admin/users'],
};

export function endpointMatchesScreenHints(endpointPath, hints) {
  const path = String(endpointPath || '').toLowerCase();
  return hints.some((hint) => path.includes(String(hint || '').toLowerCase()));
}

export function hintsForScreens(screenIds) {
  const out = [];
  for (const id of screenIds) {
    for (const hint of SCREEN_API_PATH_HINTS[id] || []) {
      if (!out.includes(hint)) out.push(hint);
    }
  }
  return out;
}

export function allMappedHints() {
  const out = [];
  for (const hints of Object.values(SCREEN_API_PATH_HINTS)) {
    for (const hint of hints) {
      if (!out.includes(hint)) out.push(hint);
    }
  }
  return out;
}
